/* eslint-disable max-len */
import _ from 'underscore';
import { jss } from 'react-jss';
import { components, names } from './components';

const calcQueue = [
  names.header,
  /*
  * Currently we only support calculate css "left" from left to right, or calculate css "top" from top to bottom.
  * However the ads copilot will be displayed at the right side of the page, which is not supported by current layout system
  * To resolve this issue, we created a container node for copilot, whose left is 0 and top is the height of the header, and the z-index is 0
  * then we will put the actual copilot component at the right side of this container node.
  */
  names.copilot,
  names.panelContainer,
  names.topBanner,
  names.promotionBanner,
  names.nav,
  names.status,
  names.messageBar,
  names.menu,
  names.tab,
  names.subTab,
  names.content,
];

const getSelection = config => _.mapObject(config, ({ mode, ...advancedOptions }, key) => {
  let result = _.result(components[key], mode, {});

  // i.e. advancedOptions = { showExperimentScoreCard: true }
  _.each(advancedOptions, (advancedOptionValue, advancedOptionName) => {
    const advancedProcessor = components[key][advancedOptionName];
    if (advancedOptionValue && _.isFunction(advancedProcessor)) {
      result = advancedProcessor(result, advancedOptionValue);
    }
  });

  return result;
});

export class StylesContainer {
  constructor(config) {
    const selected = getSelection(config);
    this.styles = _.mapObject(selected, (item, key) =>
      jss.createStyleSheet({ [key]: style => style }, { link: true }).attach());
    this.update(config);
  }

  update(config) {
    const selected = getSelection(config);
    const startPos = { top: 0, left: 0 };

    _.each(calcQueue, (key) => {
      const component = selected[key];
      this.styles[key].update(_.extend(component, startPos));
      startPos.top += _.result(component, 'height', 0);
      startPos.left += _.result(component, 'width', 0);
    });
  }
}
